(function () {
    'use strict';

    angular
        .module('app')
        .directive('signalrStatus', signalrStatus);

    signalrStatus.$inject = ['$window'];

    function signalrStatus($window) {
        // Usage:
        //     <signalrStatus></signalrStatus>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA',
            templateUrl: 'app/signalrstatus/templates/signalrstatus.html',
            controller: 'signalrStatus as vm'
        };
        return directive;

        function link(scope, element, attrs) {

            $(window.document).keyup(function (e) {
                if (e.ctrlKey && e.altKey && e.which == 83) {
                    scope.show = true;
                    scope.$apply();
                }
            });

        }
    }

})();